import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TeamMembers from './TeamMembers';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs(props) {

    console.log(props);
    console.log(props.teamData)

    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box  sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs className='training-tab' value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab className='one-tab' label="Team Form" {...a11yProps(0)} />
                    {isUserLogged.usertype === 'HRManager' || isUserLogged.usertype === "SuperAdmin" ? (<Tab className='sec-tab' label="Employee's Form" {...a11yProps(1)} />) : ''}
                    {/* <Tab label="Pending Form" {...allyProps(2)} /> */}

                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                {isUserLogged.isManager === true ?
                    <TeamMembers  teamList={props?.teamdata?.team} /> : ''
                }
            </TabPanel>
            <TabPanel value={value} index={1}>
                {(isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR") ?
                    <TeamMembers teamList={props?.teamdata?.employees} /> : ''}
            </TabPanel>
        </Box>
    );
}